import React, { useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { api } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { toast } from 'sonner';

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const nav = useNavigate();
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) { toast.error('Las contraseñas no coinciden'); return; }
    setLoading(true);
    try {
      await api.post('/auth/reset-password', { token, new_password: pw });
      toast.success('Contraseña actualizada');
      setTimeout(() => nav('/login'), 800);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Token inválido o expirado');
    } finally { setLoading(false); }
  };
  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center p-6">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle className="font-display text-3xl font-extrabold">Nueva contraseña</CardTitle>
          <p className="text-sm text-slate-500">Elige una contraseña segura.</p>
        </CardHeader>
        <CardContent>
          {!token ? (
            <div className="text-sm text-rose-600">Falta el token. Vuelve a solicitar el enlace.</div>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label>Nueva contraseña</Label>
                <Input data-testid="reset-pw1" type="password" value={pw} onChange={(e)=>setPw(e.target.value)} required minLength={6}/>
              </div>
              <div>
                <Label>Confirmar contraseña</Label>
                <Input data-testid="reset-pw2" type="password" value={pw2} onChange={(e)=>setPw2(e.target.value)} required minLength={6}/>
              </div>
              <Button data-testid="reset-submit" type="submit" disabled={loading} className="w-full rounded-full bg-blue-600 hover:bg-blue-700 border-b-4 border-blue-800 btn-tactile h-11 font-bold">
                {loading ? 'Actualizando…' : 'Actualizar contraseña'}
              </Button>
              <div className="text-sm text-slate-500 text-center">
                <Link to="/login" className="text-blue-600 font-semibold">← Volver</Link>
              </div>
            </form>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
